import { useState, useEffect } from 'react';
import { FileObjTypes } from '../../types';

const readFileMime = async (file: File): Promise<string | undefined> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onloadend = (evt) => {
      if (evt?.target?.readyState === FileReader.DONE) {
        //get mime type
        const uint = new Uint8Array(evt?.target?.result as ArrayBuffer);
        let bytes: string[] = [];
        uint.forEach((byte) => {
          bytes.push(byte.toString(16));
        });
        const hex = bytes.join('').toUpperCase();

        let mimeType;
        switch (hex) {
          case '89504E47':
            mimeType = 'image/png';
            break;
          case '47494638':
            mimeType = 'image/gif';
            break;
          case '25504446':
            mimeType = 'application/pdf';
            break;
          case 'FFD8FFDB':
          case 'FFD8FFE0':
          case 'FFD8FFE1':
            mimeType = 'image/jpeg';
            break;
          case '504B0304':
            mimeType = 'application/zip';
            break;
          default:
          //mimeType = "";
        }
        resolve(mimeType);
      }
    };

    //only read the first 4 bytes
    const blob = file.slice(0, 4);
    fileReader.readAsArrayBuffer(blob);
  });
};

type ImageDataType = {
  source: FileObjTypes;
  mimeType: string | undefined;
} | null;

const useImageFile = () => {
  const [imageData, setImageData] = useState<ImageDataType>(null);
  const [file, setFile] = useState<FileObjTypes>(null);
  const [imageSrc, setImageSrc] = useState<string>('');
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const updateData = async () => {
      setError('');
      if (file) {
        const mimeType: string | undefined = await readFileMime(file.file);
        if (mimeType && mimeType.indexOf('image') > -1) {
          setImageData({
            source: file,
            mimeType: mimeType,
          });
          const src = URL.createObjectURL(file.file);
          setImageSrc(src);
        } else {
          setImageSrc(`https://via.placeholder.com/400x400?text=InvalidImage`);
          setImageData(null);
          setError('Invalid image file');
        }
      } else {
        setImageSrc('');
        setImageData(null);
      }
    };
    updateData();
  }, [file]);

  const setImageFiles = (imgFiles: FileObjTypes[]) => {
    if (imgFiles.length > 0) setFile(imgFiles[0]);
    else setFile(null);
  };

  //return [{ imageData, imageSrc, error }, setImageFiles];
  return [{ imageData, imageSrc, error, setImageFiles }];
};

export default useImageFile;
